import { makePaymentModalErrorElem, makePaymentModalErrorListElem } from './constants'
import { paymentModalFooterButtons } from './footer'

export default function paymentModalErrors (accountingErrors = [], paymentErrors = []) {
  const errorTemplate = '<li class="alert alert-danger text-center"></li>'

  let paymentModalErrorAppend = function (errors) {
    $.each(errors, function (_indx, value) {
      makePaymentModalErrorListElem.append($(errorTemplate).text(value))
    })
  }

  makePaymentModalErrorListElem.empty()

  if (accountingErrors.length !== 0 || paymentErrors.length !== 0) {
    paymentModalErrorAppend(accountingErrors)
    paymentModalErrorAppend(paymentErrors)
    paymentModalFooterButtons(false)
    makePaymentModalErrorElem.removeClass('hide')
  } else {
    paymentModalFooterButtons(true)
    makePaymentModalErrorElem.addClass('hide')
  }
}
